module.exports = __webpack_public_path__ + "static/sodimu-30ddc5520ac6a393fc4e19943f9cafc7.png";